export const MOCK_DATA: Record<string, any>[] = [
  {
    "data": "{\"recordSource\":\"Referral\",\"landingPageActive\":false,\"coreAccountId\":\"fd683d3e-765d-ee11-be6f-000d3a314662\",\"tollFreeNumber\":\"555-555-5554\",\"productRoutingActive\":true}",
    "id": "28770b43-5425-4481-8846-403196b78db1",
    "schema_data_id": "f1e1510e-4359-4ab7-bfe5-302d64a634c5",
    "schema_data_version": 1,
    "parent_type": null,
    "latest": 1,
    "created_date": "2026-07-30T05:04:11.807Z",
    "updated_date": "2026-07-31T11:11:55.345Z",
    "schema_type_id": "29f7781b-280d-42c3-b567-7f7fc7fac8ab"
  },
  {
    "data": "{\"informativeDark\":\"#cccccc\",\"informativeLight\":\"#e5eeff\",\"informativeMedium\":\"#0049e5\",\"negativeDark\":\"#70101d\",\"negativeLight\":\"#fce9eb\",\"negativeMedium\":\"#b21a2e\",\"onPrimaryUi\":\"#ffffff\",\"positiveDark\":\"#0f6628\",\"positiveLight\":\"#e0fae7\",\"positiveMedium\":\"#11732d\",\"primaryAccent\":\"#0039b2\",\"primaryBackground\":\"#FFFFFF\",\"primaryBackgroundHover\":\"#d1e0ff\",\"primaryBackgroundSelected\":\"#c2d5ff\",\"primaryBorder\":\"#303336\",\"primaryBorderHover\":\"#d1e0ff\",\"primaryText\":\"#303336\",\"primaryUi\":\"#0039b2\",\"primaryUiBackgroundDisabled\":\"#b2cbff\",\"primaryUiForegroundDisabled\":\"#e5eeff\",\"primaryUiHover\":\"#003099\",\"secondaryAccent\":\"#c91d34\",\"secondaryBackground\":\"#f7f7f8\",\"secondaryBorder\":\"#6d7278\",\"secondaryText\":\"#000000\",\"secondaryUi\":\"#001b57\",\"tertiaryText\":\"#494c50\",\"warningDark\":\"#59390d\",\"warningLight\":\"#fcf6ed\",\"warningMedium\":\"#935f15\"}",
    "id": "3034a0fd-0203-407f-99e7-d632acc7558f",
    "schema_data_id": "24f8590a-1b10-43a1-98f6-5ff0ddcbc315",
    "schema_data_version": 1,
    "parent_type": null,
    "latest": 1,
    "created_date": "2026-07-31T05:34:14.300Z",
    "updated_date": "2026-07-31T11:11:55.345Z",
    "schema_type_id": "cc66911c-6704-4ca4-ac47-b9d83c9f7b85"
  },
  {
    "data": "{\"EXPERIENCE_TYPE\":\"standard\",\"ICON_PACK\":\"viu\",\"SUPPORTED_INSURANCE_LINES\":{\"PERSONAL_AUTO\":true,\"PERSONAL_HOME\":true,\"RENTERS\":true,\"LIFE\":true,\"CONDOMINIUM\":true,\"MOTORCYCLE\":true,\"LANDLORD\":true,\"PET\":true},\"ORDERED_INSURANCE_LINES\":[\"PERSONAL_AUTO\",\"PERSONAL_HOME\",\"RENTERS\",\"LIFE\",\"CONDOMINIUM\",\"MOTORCYCLE\",\"LANDLORD\",\"PET\"]}",
    "id": "7d05f802-be94-4e54-a471-d16905dde98f",
    "schema_data_id": "e3f7f550-cf3a-4a6f-a344-4d86bd90b27f",
    "schema_data_version": 1,
    "parent_type": null,
    "latest": 1,
    "created_date": "2026-07-31T05:34:14.301Z",
    "updated_date": "2026-07-31T11:11:55.345Z",
    "schema_type_id": "f7ff9142-238e-44e3-a374-4046a93b2531"
  },
  {
    "data": "{}",
    "id": "2d042147-ffa3-4487-a239-dbe25f1d08fb",
    "schema_data_id": "5bd409c4-6e75-4437-936b-669ef160a97a",
    "schema_data_version": 1,
    "parent_type": null,
    "latest": 1,
    "created_date": "2026-07-31T05:34:14.301Z",
    "updated_date": "2026-07-31T11:11:55.345Z",
    "schema_type_id": "b0c84f1e-9051-4708-ad4c-9ac8896aa0c0"
  },
  {
    "data": "{}",
    "id": "2a163498-e74c-498a-a9ed-cda400499c1f",
    "schema_data_id": "f5d0b3d2-6abd-42c1-9d0c-8c1d5bc73356",
    "schema_data_version": 1,
    "parent_type": null,
    "latest": 1,
    "created_date": "2026-07-31T05:34:14.301Z",
    "updated_date": "2026-07-31T11:11:55.345Z",
    "schema_type_id": "a3b37a4e-f8af-4e38-ba80-9ecdc781c275"
  },
  {
    "data": "{\"organisms\":{\"partnerLoadingScreen\":{\"quotesLoading\":{\"COMMON\":{\"nextStepsCardData\":[{},{},{}]}}}},\"routes\":{\"auto\":{\"vehicle\":{\"ownershipContent\":{\"selectOptions\":[{},{}]}}}},\"templates\":{\"optionCardsContainerScreen\":{\"discounts\":{\"discountsAvailable\":[{},{},{},{},{},{}]}}}}",
    "id": "0b87a7b8-671d-447e-9c69-82cbded27bdd",
    "schema_data_id": "160357de-7040-42fc-b50f-3480f65838bd",
    "schema_data_version": 1,
    "parent_type": null,
    "latest": 1,
    "created_date": "2026-07-31T05:34:14.302Z",
    "updated_date": "2026-07-31T11:11:55.345Z",
    "schema_type_id": "3370542b-ebfd-4db2-a726-3a660cd495af"
  },
  {
    "data": "{\"fontFamily\":{\"primary\":\"Poppins\",\"secondary\":\"Poppins\"}}",
    "id": "b97d06f5-0572-495e-b9f7-f94170122958",
    "schema_data_id": "a6b880eb-af85-41e3-805b-8922bc27e1b5",
    "schema_data_version": 1,
    "parent_type": null,
    "latest": 1,
    "created_date": "2026-07-31T05:34:14.302Z",
    "updated_date": "2026-07-31T11:11:55.345Z",
    "schema_type_id": "e5da341c-3577-4618-bca6-b93483aa7c8f"
  }
];